import React, { Component } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Constant from "../../Constant";

export default class UserTypes extends Component {
  state = {
    loading: true,
    data: [],
    columns: [
      {
        name: "Name",
        selector: "name",
        sortable: true,
      },
      {
        name: "Date",
        selector: "createdAt",
        sortable: true,
        right: true,
      },
      {
        name: "Options",
        selector: "year",
        sortable: true,
        right: true,
        cell: (row) => (
          <div className="d-flex">
            <i
              class="btn btn-light shadow-sm mx-1 fas fa-times text-danger"
              id={row.id}
              onClick={this.deleteUserType}
            ></i>
            <Link to={`/admin/user-type/${row.id}`}>
              <i
                class="btn btn-light shadow-sm mx-1 fas fa-pencil-alt text-dark"
                id={row.id}
              ></i>
            </Link>
          </div>
        ),
      },
    ],
  };
  componentDidMount() {
    this.getUserType();
  }
  getUserType = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/role/getAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        for (let i = 0; i < data.length; i++) {
          console.log(data[i]);
          var str = data[i].createdAt;
          var date = new Date(str);
          data[i].createdAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
          }-${date.getUTCFullYear()}`;
        }
        this.setState({ data: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  };
  deleteCategory = (e) => {
    var categoryId = e.target.id;

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("categoryId", categoryId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/category/delete", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        document.location.reload();
      })
      .catch((error) => console.log("error", error));
  };
  deleteUserType = (e) => {
    var userTypeId = e.target.id;

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("roleId", userTypeId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/role/delete", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        document.location.reload();
      })
      .catch((error) => console.log("error", error));
  };
  render() {
    return (
      <div className="py-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /<b> User Types</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                <Link
                  to="/admin/add-user-type"
                  className="btn btn-dark float-right"
                >
                  Add User type
                </Link>
              </div>
            </div>
          </div>

          <div className="users-container p-2">
            <DataTable
              noHeader={true}
              columns={this.state.columns}
              data={this.state.data}
              theme="solarized"
            />
          </div>
        </div>
      </div>
    );
  }
}
